import React, {useCallback, useMemo} from 'react'
import {
    AppBar, Avatar, Box, Button,
    Dialog, DialogContent, IconButton, Toolbar,
    Typography, makeStyles, Grid, TextField
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close';
import AntDataGrid from '../../shared/components/AntDataGrid';
import ReceivingResumeToolBar from './ReceivingResumeToolBar';
import useContainerDetails from "../../hooks/useContainerDetails";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    small: {
        width: theme.spacing(5),
        height: theme.spacing(5),
        margin: 0
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
}))
 
function formatToCurrency(amount) {
    return (amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}


export default function ReceivingResume({Receivings = [], ShippingOrder = [], handleClose}) {
    const classes = useStyles()

    const {ContainerCode} = Receivings?.at(0);
    
    const {data, loading: isShippingLoading} = useContainerDetails(ContainerCode);

    const Shippings = useMemo(() => {
        const list = ShippingOrder?.at(0)?.Shippings;
        const previousVer = list || [];
        return [...previousVer, ...data]
    }, [ShippingOrder, data]);

    const [isGroupingLoading, setIsGroupingLoading] = React.useState(false);
    const [itemResume, setItemResume] = React.useState([]);
    const [itemResumeS, setItemResumeS] = React.useState([]);
    const [totalShip, setToalShip] = React.useState(0);

    const isLoading = useMemo(() => isGroupingLoading || isShippingLoading, [isGroupingLoading, isShippingLoading])
    //

    const handleGroupReceiving = useCallback(() => {
        let receiveds = []

        Receivings.forEach((received) => {
            receiveds = [...receiveds, ...received.ReceivedItems]
        });
        return receiveds;
    }, [Receivings]);


    const handleGroupReceivingItemById = useCallback((receivings = []) => {
        let receivingsGroup = []

        receivings.forEach((item) => {
            let next = {...item}
            let exist = receivingsGroup.find(i => i.ItemId === item.ItemId)
            if (exist) {
                exist.Quantity += next.Quantity
            } else {
                receivingsGroup.push(next)
            }
        })

        return receivingsGroup
    }, [])


    const handleGroupShippingItem = useCallback(() => {
        let shippings = []

        Shippings.forEach((e) => {
            let next = {...e}
            let exist = shippings.find(i => i.ProductId === e.ProductId)
            if (exist) {
                exist.Quantity += next.Quantity;
                if (exist.Price < next.Price) {
                    exist.Price = next.Price;
                }

                if (exist?.ExpirationDate?.seconds > next?.ExpirationDate?.seconds) {
                    exist.ExpirationDate = next.ExpirationDate;
                }

                if (exist?.ItemClsass === next?.ItemClsass) {
                    exist.ItemClsass = next.ItemClsass
                }

            } else {
                shippings.push(next);
            }
        });

        return shippings;
    }, [Shippings]);

    const convertPriceToDollar = (price) => {
        if (price > 1000) {
            const p = (price / 1125);
            const n = Number(p);
            const r = n.toFixed(2);
            return Number(r);
        }
        return price;
    }

    const handleGroupReceivingItemWithShippingItem = useCallback((receivingGroup = [], shippingGroup = []) => {
        let groupingWithShipping = []


        receivingGroup.forEach(item => {
            let exist = shippingGroup.find(itemOrder => itemOrder.ProductId === item.ItemId)

            let res = {
                ...item,
                ShippedQuantity: 0,
                BuyPrice: 0,
                key: item.ItemId,
                ExpirationDate: '',
                Threshold: '',
                Haschilds: '',
                ItemClsass: '',
            };

            if (exist) {
                res.ShippedQuantity = exist.Quantity;
                res.BuyPrice = exist.Price;
                res = {
                    ...res,
                    ExpirationDate: exist?.ExpirationDate,
                    Threshold: exist?.Threshold,
                    Haschilds: exist?.Haschilds,
                    ItemClsass: exist?.ItemClsass,
                }
                groupingWithShipping.push(res);
                shippingGroup = shippingGroup.filter(itm => itm.ProductId !== item.ItemId);
            } else {
                groupingWithShipping.push(res);
            }
        });


        let convertRestShipping = shippingGroup.map(itm => {
            return {
                BuyPrice: convertPriceToDollar(itm.Price),
                ExpirationDate: itm.ExpirationDate,
                InternalId: itm.InternalId,
                ItemBarcode: itm.ProductBarcode,
                ItemId: itm.ProductId,
                key: itm.ProductId,
                ItemImageUrl: itm.ProductImageUrl,
                ItemName: itm.ProductName,
                Quantity: 0,
                QuantityForDekon: 0,
                SellPrice: itm.SellPrice || itm.Price,
                ShippedQuantity: itm.Quantity,
                Threshold: itm?.Threshold,
                Haschilds: itm?.Haschilds,
                ItemClsass: itm?.ItemClsass,
            }
        });
        groupingWithShipping.push(...convertRestShipping)

        return groupingWithShipping;
    }, [])

    const groupingItems = useCallback(() => {
        setIsGroupingLoading(true)
        let shippingGroup = handleGroupShippingItem()
        let receivings = handleGroupReceiving()
        let receivingGroup = handleGroupReceivingItemById(receivings)
        let allItemGrouping = handleGroupReceivingItemWithShippingItem(receivingGroup, shippingGroup);

        allItemGrouping.sort((a, b) => {
            if (a.ItemName < b.ItemName)
                return -1
            if (a.ItemName > b.ItemName)
                return 1
            return 0
        });


        setItemResumeS(allItemGrouping)
        setItemResume(allItemGrouping)
        setIsGroupingLoading(false)
    }, [handleGroupShippingItem, handleGroupReceiving, handleGroupReceivingItemById, handleGroupReceivingItemWithShippingItem])

    const LineCheck = (text, row, index) => ({
        props: {
            style: {
                background: row.Quantity < row.ShippedQuantity ? '#FFCCD2'
                    : row.Quantity > row.ShippedQuantity ? '#FEF2AE' : ''
            }
        },
        children: text,

    })

    const columns = [
        {
            title: 'Image', dataIndex: "ItemImageUrl", key: 'ItemImageUrl',
            render: ImageUrl => {
                return (ImageUrl !== null && ImageUrl !== "") ?
                    <Avatar src={ImageUrl} alt='image' className={classes.small}/> :
                    <Avatar> no </Avatar>
            }
        },
        {
            title: 'Nom Produit', dataIndex: 'ItemName', key: 'ItemName',
            render: (text, row, index) => LineCheck(text, row, index)
        },
        {
            title: 'Code barre', dataIndex: 'ItemBarcode', key: 'ItemBarcode',
            render: (text, row, index) => LineCheck(text, row, index)
        },
        {
            title: 'Prosoft Code', dataIndex: 'InternalId', key: 'InternalId',
            render: (text, row, index) => LineCheck(text, row, index)
        },
        {
            title: 'Déja Compté', dataIndex: 'Quantity', key: 'Quantity',
            render: (text, row, index) => LineCheck(text, row, index)
        },
        {
            title: 'Qté Dekon', dataIndex: 'QuantityForDekon', key: 'QuantityForDekon',
            render: (text, row, index) => LineCheck(text, row, index)
        },
        {
            title: 'Quantité Livrée', dataIndex: 'ShippedQuantity', key: 'ShippedQuantity',
            render: (text, row, index) => LineCheck(text, row, index)
        },
        {
            title: '$ Price', dataIndex: 'BuyPrice', key: 'BuyPrice',
            render: (price, row, index) => LineCheck(`$${price}`, row, index)
        },
        {
            title: 'Prix de Vente', dataIndex: 'SellPrice', key: 'SellPrice',
            render: (price, row, index) => LineCheck(`${price} FCFA`, row, index)
        },
    ]

    React.useEffect(() => {
        groupingItems();
    }, [groupingItems]);

    const handleSearchByName = (text) => {
        let searchs = itemResumeS;
        if (text === '') {
            setItemResume(itemResumeS);
            return;
        }

        const response = []
        searchs.forEach(r => {
            let res = r.ItemName.toString().toLowerCase().includes(text.toString().toLowerCase())
            if (res) {
                response.push(r);
            }
        })
        setItemResume(response);
    }

    const handleSearchByBarecode = (text) => {
        let searchs = itemResumeS;
        if (text === '') {
            setItemResume(itemResumeS);
            return;
        }

        const response = []
        searchs.forEach(r => {
            let res = r?.ItemBarcode?.toString()?.toLowerCase().includes(text.toString().toLowerCase())
            if (res) {
                response.push(r);
            }
        })
        setItemResume(response);
    }

    const handleSearchByProsoft = (text) => {
        let searchs = itemResumeS;
        if (text === '') {
            setItemResume(itemResumeS);
            return;
        }

        const response = []
        searchs.forEach(r => {
            let res = r?.InternalId?.toString()?.toLowerCase().includes(text.toString().toLowerCase())
            if (res) {
                response.push(r);
            }
        })
        setItemResume(response);
    }

    const ReturnToolBar = useCallback((props) => {
        return <ReceivingResumeToolBar {...props}
                                       totalCount={`TOTAL BUY PRICE FOR COUNT ITEM: $${formatToCurrency(totalShip)}`}/>
    }, [totalShip])

    const resume = useMemo(() => {
        const result= itemResume.map(one => {
            const {BuyPrice, SellPrice} = one;
            const newBuyPrice = (BuyPrice === 0) ? (SellPrice / 1125).toFixed(2) : BuyPrice;
            const parsed = (newBuyPrice > 1000) ? (newBuyPrice / 1125).toFixed(2) : newBuyPrice;

            return {...one, BuyPrice: Number(parsed)}
        })

        setToalShip(c => 0);
        // console.log(itemResume)
        result.forEach(item => {
            let price = item.BuyPrice * item.Quantity
            setToalShip(c => c + price);
        });

        return result;
    }, [itemResume]);

    // console.log(resume.filter(({BuyPrice}) => BuyPrice === 0));

    return (
        <Dialog fullScreen open onClose={handleClose}>
            <AppBar position="relative" title="Rapport des receiptions">
                <Toolbar style={{justifyContent: 'space-between'}}>
                    <Box>
                        <Typography> {" RAPPORT DES RECEPTIONS "} </Typography>
                    </Box>
                    <Box>
                        <IconButton edge="start" color="inherit" onClick={handleClose}>
                            <CloseIcon/>
                        </IconButton>
                        <Button color="inherit" onClick={handleClose}>
                            retour
                        </Button>
                    </Box>
                </Toolbar>
            </AppBar>

            <DialogContent>
                <div>
                    <Grid container spacing={2}>
                        <Grid item>
                            <TextField label="chercher par nom"
                                       variant="outlined" margin="dense"
                                       onChange={(e) => handleSearchByName(e.currentTarget.value)}
                            />
                        </Grid>

                        <Grid item>
                            <TextField label="chercher par code barre"
                                       variant="outlined" margin="dense"
                                       onChange={(e) => handleSearchByBarecode(e.currentTarget.value)}
                            />
                        </Grid>

                        <Grid item>
                            <TextField label="chercher par Prosfot Id"
                                       onChange={(e) => handleSearchByProsoft(e.currentTarget.value)}
                                       variant="outlined" margin="dense"/>
                        </Grid>
                        <Grid container item>
                            <Grid container item spacing={1}>
                                <Grid item>
                                    <Box
                                        style={{
                                            width: 20,
                                            height: 20,
                                            display: "flex",
                                            backgroundColor: "#FEF2AE",

                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography variant="overline"> Quantity counted greater than the quantity
                                        shipped </Typography>
                                </Grid>

                            </Grid>
                            <Grid container item spacing={1}>
                                <Grid item>
                                    <Box
                                        style={{
                                            width: 20,
                                            height: 20,
                                            display: "flex",
                                            backgroundColor: "#FEB2A9",

                                        }}
                                    />
                                </Grid>
                                <Grid item>
                                    <Typography variant="overline"> Quantity counted less than the quantity
                                        shipped </Typography>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                    <AntDataGrid
                        columns={columns}
                        ToolBar={ReturnToolBar}
                        data={resume}
                        isLoading={isLoading}
                    />
                </div>
            </DialogContent>
        </Dialog>
    )
}
